import { render, staticRenderFns } from "./HostingDnsTable.vue?vue&type=template&id=e0956738&scoped=true"
import script from "./HostingDnsTable.vue?vue&type=script&lang=js"
export * from "./HostingDnsTable.vue?vue&type=script&lang=js"
import style0 from "./HostingDnsTable.vue?vue&type=style&index=0&id=e0956738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0956738",
  null
  
)

export default component.exports